import { EntityType } from 'app/agriculture/models/Entities';

import {
    bridgeCrossingIcon,
    coolRoomIcon,
    damIcon,
    erosionAreaIcon,
    fenceIcon,
    gateIcon,
    herdIcon,
    houseIcon,
    noteIcon,
    paddockIcon,
    shedIcon,
    siloIcon,
    tankIcon,
    taskIcon,
    troughIcon,
    vegetationIcon,
    waterwayIcon,
    yardIcon,
} from 'app/agriculture/icons/assets';
import { IconManifest } from 'app/agriculture/icons/types';
import { MapIconOptions } from 'app/agriculture/icons/utils/map-icon-utils/types';
import { isKeyOfObject } from 'app/agriculture/type-utils/isKeyOfObject/isKeyOfObject';
import { signalIcon } from 'app/agriculture/icons/SignalIcon';
import { primaryColourMain } from 'app/agriculture/material';

type AssetIconEntityType = EntityType;

const assetIconConfig: Record<
    AssetIconEntityType,
    {
        icon?: IconManifest;
        options?: MapIconOptions;
    }
> = {
    Device: {
        icon: signalIcon,
    },
    Boundary: {
        options: { borderColor: '#FCC443' },
    },
    Task: {
        icon: taskIcon,
        options: { color: primaryColourMain, billboardType: 'pin', shouldIncludeBorder: true },
    },
    Note: {
        icon: noteIcon,
        options: { color: '#FC641F', billboardType: 'pin', shouldIncludeBorder: true },
    },
    Herd: {
        icon: herdIcon,
        options: { color: '#1e1f22', billboardType: 'pin', shouldIncludeBorder: true },
    },
    ProtagAnimal: {
        options: { color: '#7555E3', billboardType: 'smallCircle', shouldIncludeBorder: true },
    },
    Yard: { icon: yardIcon, options: { overlayColor: '#66a5fa', borderColor: '#66a5fa' } },
    Waterway: { icon: waterwayIcon, options: { borderColor: '#0277b6' } },
    'Bridge Crossing': { icon: bridgeCrossingIcon, options: { color: '#FC641F' } },
    Vegetation: {
        icon: vegetationIcon,
        options: { overlayColor: '#018131', borderColor: '#018131' },
    },
    Tank: { icon: tankIcon, options: { color: '#2686CB' } },
    Paddock: { icon: paddockIcon, options: { overlayColor: '#FF8B2E', borderColor: '#FF8B2E' } },
    Silo: { icon: siloIcon, options: { color: '#F12948' } },
    Shed: { icon: shedIcon, options: { color: '#F34235' } },
    House: { icon: houseIcon, options: { color: '#23B550' } },
    Trough: { icon: troughIcon, options: { color: '#60219a' } },
    Gate: { icon: gateIcon, options: { color: '#7555E3' } },
    Fence: { icon: fenceIcon, options: { borderColor: '#23B550' } },
    'Erosion Area': {
        icon: erosionAreaIcon,
        options: { overlayColor: '#FEC006', borderColor: '#FEC006' },
    },
    Dam: { icon: damIcon, options: { overlayColor: '#0F4B77', borderColor: '#0F4B77' } },
    'Cool Room': { icon: coolRoomIcon, options: { color: primaryColourMain } },
};

export function getAssetIconConfig(entityType: EntityType): {
    icon?: IconManifest;
    options?: MapIconOptions;
} {
    if (!isKeyOfObject(entityType, assetIconConfig)) return {};
    return assetIconConfig[entityType];
}
